module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8n7r2r5n-978313795ca9abe049ce0833ca782742.svg";